import React from "react";
import img from "../../assets/img/homeImg1.jpeg";
import "./About.css";
import { Link } from "react-router-dom";

export default function About(props) {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-7 col-sm-12 d-flex align-items-center">
          <div className="circle-container rounded-circle border mt-5">
            <img alt="about" className="img-fluid" src={img} />
          </div>
          <div className="circle-container-small mt-5"></div>
          <div className="circle-container-xs mt-5">
            <h1 className="orange-text year pb-4">4</h1>
            <p className="blue-text experience">Years of Experience</p>
          </div>
        </div>
        <div className="col-md-5 col-sm-12">
          <h4 className="orange-text text-left mt-5 fw-bold">About</h4>
          <h1 className="mt-1 head-text">Welcome to OOKlass</h1>
          <p className="font-18">
            Welcome to our tuition classes where we are dedicated to providing
            quality education and support to students from <strong>6th to 12th grade </strong>in
            the subjects of Science and Maths.
          </p>
          <ul className="list-unstyled">
            <li className="p-2 blue-text fw-bold">
              <i className="bi-check-circle-fill icon-orange"></i> Separate
              classes for Physics, Chemistry and Maths for 10th, 11th and 12th
              grade students
            </li>
            <li className="p-2 blue-text fw-bold">
              <i className="bi-check-circle-fill icon-orange"></i> Doubt
              sessions and weekly tests to ensure clear understanding and
              progress evaluation
            </li>
            <li className="p-2 blue-text fw-bold">
              <i className="bi-check-circle-fill icon-orange"></i> Online
              reports of student performance available for parents and students
            </li>
          </ul>
          {props.show && (
            <div className="route">
              <Link to="aboutus">
                <div className="btn btn-orange mb-5">Read More</div>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
